import { CapoPlugin } from "/var/www/marketplace-dev.ingeniuscloud.net/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];